import { createStore, applyMiddleware, combineReducers } from 'redux';
import { composeWithDevTools } from 'remote-redux-devtools';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import { browserHistory } from 'react-router';
import thunk from 'redux-thunk';
import { autoRehydrate } from 'redux-persist';
import { userReducer } from './reducers';


export default function configureStore(initialState) {
  const enhancer = composeWithDevTools(
    applyMiddleware(thunk),
    autoRehydrate(),
    applyMiddleware(routerMiddleware(browserHistory)),
  );
  const reducers = combineReducers({
    routing: routerReducer,
    form: formReducer,
    user: userReducer,
  });
  const store = createStore(reducers, initialState, enhancer);
  return store;
}



// WEBPACK FOOTER //
// ./src/configureStore.js